import { Link } from "react-router-dom"
import styles from "./SiteFooter.module.css"

// EDINET利用規約(PDL1.0) 1.1項の出典表示義務、および1.1項イ号の「加工した旨・
// 主体の明記」義務に対応。詳細な出典・免責事項は/disclaimerに集約し、各ページの
// フッターからはそこへのリンクのみを置く（属性表示を一箇所にまとめた方が読みやすく、
// 出典を明確にリンクで示す形は一般的な開示方法として問題ない）。
export function SiteFooter() {
  const year = new Date().getFullYear()
  return (
    <footer className={styles.footer}>
      <p>
        <Link to="/disclaimer">データの出典・免責事項</Link>
      </p>
      <p>© {year} 株主優待ナビ</p>
    </footer>
  )
}
